/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:14:33
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { toVisualThousands } from "../utils";
import { labelFont } from "../visualConfig";

export default ({ list = [], color=[] }) => {
  const len = list.length;
  const width = 100 / len;

  return {
    title: {
      // text: 'World Population'
    },
    color,
    legend: {
      show: false,
    },
    grid: {
      left: 0,
      right: 0,
    },
    series: list.map((item, index) => {
      return {
        name: item.name,
        type: 'pie',
        radius: 80,
        center: [`${width * index + width / 2}%`, '50%'],
        data: item.list,
        label: {
          show: true,
          formatter: (ele) => `${toVisualThousands(ele.value)}\n(${ele.percent}%)`,
          ...labelFont,
        }
      }
    })
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P23/chart.js